import type { JournalHoldingsTreeItem } from "@/lib/api/catalog";
import { formatAccessionNumber } from "@/lib/utils/catalog-formatting";

export function JournalLegacyCopyList({ items }: { items: JournalHoldingsTreeItem[] }) {
  if (items.length === 0) {
    return (
      <p className="rounded-lg border border-dashed p-6 text-center text-sm text-muted-foreground">
        No legacy copies are available.
      </p>
    );
  }

  return (
    <ul className="divide-y rounded-lg border" aria-label="Legacy journal copies">
      {items.map((item) => (
        <li key={item.id} className="grid gap-1 px-4 py-3 text-sm sm:grid-cols-2 lg:grid-cols-4">
          <span>
            <span className="text-muted-foreground">Accession: </span>
            {formatAccessionNumber(item.accessionNumber) || item.accessionNumber}
          </span>
          <span>
            <span className="text-muted-foreground">Barcode: </span>
            <span className="font-mono">{item.barcode}</span>
          </span>
          <span>
            <span className="text-muted-foreground">Status: </span>
            {item.statusCode}
          </span>
          {item.location?.name ? (
            <span>
              <span className="text-muted-foreground">Location: </span>
              {item.location.name}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
